import {Subscription} from "../services/restserver-openapi";

export function statusGerman(status?: string) {
    if (!status) {
        return status;
    }
    switch (status.toLowerCase()) {
        case "future":
            return "demnächst";
        case "active":
            return "aktiv";
        case "in_trial":
            return "testphase";
        case "non_renewing":
            return "läuft aus";
        case "paused":
            return "pausiert";
        case "cancelled":
            return "abgebrochen";
        case "transferred":
            return "übertragen";
        default:
            return status;
    }
}

export function statusColor(status?: string) {
    if (!status) {
        return 'primary';
    }
    switch (status.toLowerCase()) {
        case "future":
            return "info";
        case "active":
            return "success";
        case "in_trial":
            return "warning";
        case "non_renewing":
            return "error";
        case "paused":
            return "info";
        case "cancelled":
            return "error";
        case "transferred":
            return "info";
        default:
            return 'primary';
    }
}

export function billingPeriodUnitGerman(billingPeriodUnit?: string) {
    if (!billingPeriodUnit) {
        return billingPeriodUnit;
    }
    switch (billingPeriodUnit.toLowerCase()) {
        case "day":
            return "Tag";
        case "week":
            return "Woche";
        case "month":
            return "Monat";
        case "year":
            return "Jahr";
        case "threemonth": // könnte anders heissen
            return "Saison (3 Monate)";
        default:
            return billingPeriodUnit;
    }
}

export function getTotalPriceWithoutCharges(subscription: Subscription) {
    const totalInCents = subscription.subscriptionItems?.reduce((acc, item) => {
        if (item.itemType !== "CHARGE") {
            return acc + item.amount!;
        }
        return acc;
    }, 0);
    return convertPrice(totalInCents!, subscription.currencyCode!)
}

export function convertPrice(amount: number, currency: string) {
    return (amount / 100).toFixed(2) + ' ' + currency;
}

export function getSubscriptionName(subscription: Subscription) {
    if (subscription.subscriptionItems?.some(item => item.itemPriceId?.startsWith('host-free'))) {
        return "Host Free";
    }
    if (subscription.subscriptionItems?.some(item => item.itemPriceId?.startsWith('host-flat'))) {
        return "Host Pro";
    }
    if (subscription.subscriptionItems?.some(item => item.itemPriceId?.startsWith('host-flex'))) {
        return "Host Flex";
    }
    if (subscription.subscriptionItems?.some(item => item.itemPriceId?.startsWith('vanlifer-free'))) {
        return "Free";
    }
    if (subscription.subscriptionItems?.some(item => item.itemPriceId?.startsWith('vanlifer-premium-CHF-Monthly'))) {
        return "Premium";
    }
    if (subscription.subscriptionItems?.some(item => item.itemPriceId?.startsWith('vanlifer-premium-CHF-Every-3-months'))) {
        return "Premium";
    }
    if (subscription.subscriptionItems?.some(item => item.itemPriceId?.startsWith('vanlifer-premium-CHF-Yearly'))) {
        return "Premium";
    }
    if (subscription.subscriptionItems?.some(item => item.itemPriceId?.startsWith('vanlifer-early-access-CHF-Every-5-years'))) {
        return "Early Access";
    }
    if (subscription.subscriptionItems?.some(item => item.itemPriceId?.startsWith('vanlifer-early-access-CHF-Yearly'))) {
        return "Early Access";
    }
}

export function formatChargebeeDate(dateString: string) {
    const date = new Date(dateString);
    if (date.getTime() === new Date('1970-01-01').getTime()) {
        return '';
    } else {
        return date.toLocaleDateString();
    }
}

export function isHostSubscription(subscription: Subscription) {
    return subscription.subscriptionItems?.some(item => item.itemPriceId?.startsWith('host'));
}

export function isEarlyAccessSubscription(subscription: Subscription) {
    return subscription.subscriptionItems?.some(item => item.itemPriceId?.startsWith('vanlifer-early-access'));
}